export const SET_DATA_ROWS_NOTA_DEBITO = 'casos/SET_DATA_ROWS_NOTA_DEBITO';
export const GET_DATA_ROWS_NOTA_DEBITO = 'casos/GET_DATA_ROWS_NOTA_DEBITO';
export const FETCH_DATA_NOTA_DEBITO = 'casos/FETCH_DATA_NOTA_DEBITO';
